import { NotFoundContainer } from '../containers/NotFound'

/**
 * The NotFound page.
 */
const NotFound = () => {
  return <NotFoundContainer />
}

export default NotFound
